export default "__VITE_ASSET__CMRZJeGc__"